import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

const Breadcrumb = ({ items }) => {
  return (
    <div className="text-sm text-yellow-700 mb-6 flex items-center flex-wrap gap-2">
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          {item.path ? (
            <Link
              to={item.path}
              className="hover:text-yellow-900 font-medium"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-600">{item.label}</span>
          )}

          {index !== items.length - 1 && (
            <FaChevronRight className="text-xs text-gray-400" />
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;